module.exports = __webpack_public_path__ + "static/img/gerard.16a58f3b.jpg";